import { NgModule } from '@angular/core';

import { IntegrationTituloReceberSharedModule } from '../configuracoes/integration/titulo-receber';
import { ClienteTypeaheadSharedModule } from '../pessoa/cliente/typeahead/cliente-typeahead-shared.module';
import { RepresentanteSharedModule } from '../pessoa/representante';
import { TituloReceberFilterModule } from './filter';
import { TituloReceberFormModule } from './form';
import { TituloReceberIntegracaoErpImportModule } from './integracoes/erp/import';

import { TituloReceberRoutingModule } from './titulo-receber-routing.module';
import { TituloReceberViewContainerModule } from './view/container';


@NgModule({
    imports: [
        TituloReceberRoutingModule,
        TituloReceberFilterModule,
        TituloReceberViewContainerModule,
        TituloReceberFormModule,
        IntegrationTituloReceberSharedModule,
        ClienteTypeaheadSharedModule,
        RepresentanteSharedModule,
        TituloReceberIntegracaoErpImportModule
    ]
})
export class TituloReceberModule { }
